import { useEffect } from 'react';
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from 'react-router-dom';
import { init, reactRouterV6BrowserTracingIntegration } from '@sentry/react';

import { appEnv } from '@izimi/core';

import { version } from '../../../../../package.json';

if (import.meta.env.PROD) {
  init({
    dsn: 'https://2abc5a70000946c89ce06d7d31a37b7d@o548562.ingest.sentry.io/6547789',
    integrations: [
      reactRouterV6BrowserTracingIntegration({
        useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
    ],
    environment: appEnv,
    release: version,
    autoSessionTracking: false,
  });
}
